import { useLoader } from '@react-three/fiber';
import * as THREE from 'three';
import { Shape } from 'three';
import { useMemo } from 'react';

const LambaDolgu = ({ position = [0, 0, 0], scale = 1 }) => {
  const shape = useMemo(() => {

    const w = 0.19;
    const h = 0.111;
    const r = 0.01;

    const s = new Shape();
    s.moveTo(-w / 2 + r, -h / 2);
    s.lineTo(w / 2 - r, -h / 2);
    s.quadraticCurveTo(w / 2, -h / 2, w / 2, -h / 2 + r);
    s.lineTo(w / 2, h / 2 - r);
    s.quadraticCurveTo(w / 2, h / 2, w / 2 - r, h / 2);
    s.lineTo(-w / 2 + r, h / 2);
    s.quadraticCurveTo(-w / 2, h / 2, -w / 2, h / 2 - r);
    s.lineTo(-w / 2, -h / 2 + r);
    s.quadraticCurveTo(-w / 2, -h / 2, -w / 2 + r, -h / 2);

    return s;
  }, [scale]);

  return (
    <mesh position={position}>
      <extrudeGeometry args={[shape, { depth: 0.1, bevelEnabled: false }]} />
      <meshStandardMaterial color="#dddddd" />
    </mesh>
  );
};

const DamlaLambaDolgu = ({ position = [0, 0, 0], scale = 1 }) => {
  const shape = useMemo(() => {
    const s = new Shape();

    const w = 0.19 * scale;
    const h = 0.35 * scale;

    // Damla şekli: aşağıdan yukarı kavisli
    s.moveTo(-w / 2, 0);
    s.lineTo(-w / 2, 0);
    s.quadraticCurveTo(0, h, w / 2, 0);
    s.lineTo(w / 2, 0);
    s.lineTo(-w / 2, 0); // Kapat

    return s;
  }, [scale]);

  return (
    <mesh position={position}>
      <extrudeGeometry args={[shape, { depth: 0.1, bevelEnabled: false }]} />
      <meshStandardMaterial color="#dddddd" />
    </mesh>
  );
};

const FencePost = ({ isShowAnkraj, led, topLed, height, color = "#999", position = [0, 0, 0], angle }) => {
  const postWidth = 0.2;
  const footHeight = 0.05;
  const topBoxHeight = 0.05;

  const [x, y, z] = position;
  const damlaTexture = useLoader(THREE.TextureLoader, '/drop_lamp.png');
  const lampTexture = useLoader(THREE.TextureLoader, '/lamp.png');

  return (
    <>
      {/* Ana direk */}
      <mesh position={[x, y, z]}>
        <boxGeometry args={[postWidth, height, postWidth]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Alt ayak (zemin parçası) */}
      {isShowAnkraj && (<mesh position={[x, y - height / 2 + footHeight / 2, z]}>
        <boxGeometry args={[postWidth + 0.05, footHeight, postWidth + 0.05]} />
        <meshStandardMaterial color="#888888" />
      </mesh>)}

      {/* Üst profil kutusu - topLed === '2' */}
      {topLed === '2' && (
        <mesh position={[x, y + height / 2 + topBoxHeight / 2, z]}>
          <boxGeometry args={[topBoxHeight, topBoxHeight, topBoxHeight]} />
          <meshStandardMaterial color={color} />
        </mesh>
      )}

      {/* Damla Lamba Ön */}
      {topLed === '1' && angle == "0" && (
        <mesh position={[x, y + height / 2 + 0.1, z + 0.05]} rotation={[0, 0, 0]}>
          <planeGeometry args={[0.2, 0.2]} />
          <meshBasicMaterial map={damlaTexture} transparent />
        </mesh>
      )}
      {/* Dolgu Damla Ara Boşluk */}
      {topLed === '1' && angle == "0" && (<DamlaLambaDolgu position={[x, y + height / 2 + 0.025, z - 0.05]} />)}

      {/* Damla Lamba Arka */}
      {topLed === '1' && angle == "0" && (
        <mesh position={[x, y + height / 2 + 0.1, z - 0.05]} rotation={[0, 0, 0]}>
          <planeGeometry args={[0.2, 0.2]} />
          <meshBasicMaterial map={damlaTexture} transparent side={THREE.DoubleSide} />
        </mesh>
      )}

      {/*  Lamba Ön */}
      {topLed === '0' && angle == "0" && (
        <mesh position={[x, y + height / 2 + 0.07, z + 0.05]} rotation={[0, 0, 0]}>
          <planeGeometry args={[0.2, 0.15]} />
          <meshBasicMaterial map={lampTexture} transparent />
        </mesh>
      )}
      {/* Dolgu Damla Ara Boşluk */}
      {topLed === '0' && angle == "0" && (<LambaDolgu position={[x, y + height / 2 + 0.085, z - 0.05]} />)}

      {/*  Lamba Arka */}
      {topLed === '0' && angle == "0" && (
        <mesh position={[x, y + height / 2 + 0.07, z - 0.05]} rotation={[0, 0, 0]}>
          <planeGeometry args={[0.2, 0.15]} />
          <meshBasicMaterial map={lampTexture} transparent side={THREE.DoubleSide} />
        </mesh>
      )}

      {/* LED şeritler - sadece led==1 ise */}
      {led == '1' && (
        <>
          {/* Sol LED */}
          <mesh position={[x - postWidth / 2 + 0.02, y, z + postWidth / 2 + 0.001]}>
            <boxGeometry args={[0.01, height, 0.005]} />
            <meshStandardMaterial color="yellow" emissive="yellow" emissiveIntensity={2} />
          </mesh>

          {/* Sağ LED */}
          <mesh position={[x + postWidth / 2 - 0.02, y, z + postWidth / 2 + 0.001]}>
            <boxGeometry args={[0.01, height, 0.005]} />
            <meshStandardMaterial color="yellow" emissive="yellow" emissiveIntensity={2} />
          </mesh>


          {/* Sol LED */}
          <mesh position={[x - postWidth / 2 + 0.02, y, z - postWidth / 2 - 0.001]}>
            <boxGeometry args={[0.01, height, 0.005]} />
            <meshStandardMaterial color="yellow" emissive="yellow" emissiveIntensity={2} />
          </mesh>

          {/* Sağ LED */}
          <mesh position={[x + postWidth / 2 - 0.02, y, z - postWidth / 2 - 0.001]}>
            <boxGeometry args={[0.01, height, 0.005]} />
            <meshStandardMaterial color="yellow" emissive="yellow" emissiveIntensity={2} />
          </mesh>
        </>
      )}
    </>
  );
};

export default FencePost;